import React from "react";
import { apiUploadImage } from "./apiClient";
import { resolveMediaUrl } from "./mediaUrl";

export function ImageUploadField({ label, value, onChange, accept = "image/*", className = "" }) {
  const [uploading, setUploading] = React.useState(false);
  const [error, setError] = React.useState("");

  const onFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploading(true);
    setError("");
    const res = await apiUploadImage("/api/Uploads/image", file);
    if (!res.ok) {
      setError(res.error ?? "Upload failed.");
    } else {
      const uploadedPath = res.data?.path ?? "";
      onChange(uploadedPath);
    }
    setUploading(false);
  };

  const canPreview = typeof value === "string" && value.trim().length > 0;
  const previewSrc = resolveMediaUrl(value);

  return (
    <label className={["field", className].filter(Boolean).join(" ")}>
      <span>{label}</span>
      <input type="file" accept={accept} onChange={onFileChange} />
      {uploading && <small>Uploading...</small>}
      {error && <small className="upload-error">{error}</small>}
      {canPreview && (
        <div className="image-upload-preview">
          <img src={previewSrc} alt={label} />
          <button type="button" className="btn btn-ghost btn-sm" onClick={() => onChange("")}>
            Remove
          </button>
        </div>
      )}
    </label>
  );
}
